import MediatorPanel from '../mediator_panel'

window.MediatorPanel = MediatorPanel